import { FC, ReactElement } from 'react'

import {
    IconArrow,
    IconBell,
    IconCalendar,
    IconCalendarExport,
    IconChatBubble,
    IconCheck,
    IconCheckCircle,
    IconChevronDown,
    IconChevronLeft,
    IconChevronRight,
    IconClockOutline,
    IconCrossClose,
    IconFileText,
    IconGroup,
    IconHamburger,
    IconHeart,
    IconHome,
    IconInfoCircle,
    IconLogOut,
    IconMegaphone,
    IconPlus,
    IconRepeat,
    IconStar,
    IconTarget,
    IconThumbsUp,
    IconUser,
    IconWarningTriangle,
} from './set'

import './Icon.scss'

export interface SvgIconProps {
    className?: string
}

const icons = {
    arrow: IconArrow,
    bell: IconBell,
    calendar: IconCalendar,
    'calendar-export': IconCalendarExport,
    'chat-bubble': IconChatBubble,
    check: IconCheck,
    'check-circle': IconCheckCircle,
    'chevron-down': IconChevronDown,
    'chevron-left': IconChevronLeft,
    'chevron-right': IconChevronRight,
    'clock-outline': IconClockOutline,
    'cross-close': IconCrossClose,
    'file-text': IconFileText,
    group: IconGroup,
    hamburger: IconHamburger,
    heart: IconHeart,
    home: IconHome,
    'info-circle': IconInfoCircle,
    'log-out': IconLogOut,
    megaphone: IconMegaphone,
    plus: IconPlus,
    repeat: IconRepeat,
    star: IconStar,
    target: IconTarget,
    'thumbs-up': IconThumbsUp,
    user: IconUser,
    'warning-triangle': IconWarningTriangle,
}

export type IconName = keyof typeof icons

export interface IconProps extends SvgIconProps {
    name: IconName
}

export const Icon: FC<IconProps> = ({ name, className = '' }): ReactElement | null => {
    const IconComponent = icons[name] ? icons[name] : null

    return IconComponent
        ? <IconComponent className={className} />
        : null
}
